import React, { useContext } from 'react'
import moment from 'moment'
import {ModalContext, UserContext, TourContext} from "../../../context/index"
import { AUTH_LOGIN } from '../../../constant'
import css from './Footer.module.scss'
import layout from '../Layout.module.scss'

export default function Footer() {
	const { openModal } = useContext(ModalContext)
	const { openTour } = useContext(TourContext)
	const { user } = useContext(UserContext)

	const onClick = function (e) {
		e.preventDefault()
		const name = e.target.name

		if(name){
			openModal(name)
		}
	}

	return (
		<footer className={css.footer}>
			<div className={layout.layout}>
				<nav className={css.nav}>
					<button name="about" className={css.navItem} onClick={onClick}>О базе анонсов</button>
					<a href="/Guide_Announces_Base.pdf" className={css.navItem} download>Руководство пользователя</a>
					<a href="https://riarating.ru/calendar_acquiring/" className={css.navItem}>Календарь&nbsp;дат&nbsp;и&nbsp;событий</a>
						{user?.auth === AUTH_LOGIN
							? <button name="feedback" className={css.navItem} onClick={onClick}>Написать редактору</button>
						: null
					}
					<a href="https://россиясегодня.рф/#productsandservices" className={css.navItem}>Продукты и сервисы Медиагруппы «Россия сегодня»</a>

					{/*{user?.auth === AUTH_LOGIN*/}
					{/*	? <>*/}
					{/*		<button name="about" className={css.navItem} onClick={onClick}>О базе анонсов</button>*/}
					{/*		<a href="/Guide_Announces_Base.pdf" className={css.navItem} download>Руководство*/}
					{/*			пользователя</a>*/}
					{/*		<button name="feedback" className={css.navItem} onClick={onClick}>Написать редактору*/}
					{/*		</button>*/}
					{/*		<button onClick={() => openTour({tour: 1, stepIndex: 2})} className={css.navItem}>Узнать,*/}
					{/*			что нового в Базе анонсов*/}
					{/*		</button>*/}
					{/*	</>*/}
					{/*	: <>*/}
					{/*		<button name="about" className={css.navItem} onClick={onClick}>О базе анонсов</button>*/}
					{/*		<a href="/Guide_Announces_Base.pdf" className={css.navItem} download>Руководство*/}
					{/*			пользователя</a>*/}
					{/*		<a href="https://россиясегодня.рф/#productsandservices" className={css.navItem}>Продукты и*/}
					{/*			сервисы Медиагруппы «Россия сегодня»</a>*/}
					{/*		<button onClick={() => openTour({tour: 1, stepIndex: 0})} className={css.navItem}>Узнать,*/}
					{/*			что нового в Базе анонсов*/}
					{/*		</button>*/}
					{/*	</>*/}
					{/*}*/}
				</nav>
				<div className={css.copyright}>
					<div>
						<div className={css.text}>Оформить подписку: <a
							href="mailto:podpiska@ria.ru">podpiska@ria.ru</a></div>
						<div className={css.text}>© {moment().format('YYYY')} Медиагруппа «Россия сегодня»</div>
					</div>
					<div className={css.right}>
						<div><a href="https://xn--c1acbl2abdlkab1og.xn--p1ai/privacy_policy/" target="_blank" className={css.link}>Политика конфиденциальности</a></div>
						<div><button name="feedbackPersonal" className={css.link} onClick={onClick}>Обратная связь</button></div>
						<div><a href="https://xn--c1acbl2abdlkab1og.xn--p1ai/privacy_policy/#confidentiality5" target="_blank" className={css.link}>Правила применения рекомендательных технологий</a></div>
					</div>
				</div>
			</div>
		</footer>
	)
}